$(document).ready(function () {
  var hash = location.hash;
  if (hash == "#article_top") {
    window.helpers.scrollTo.go($(".gram-index-article"), -40);
  }
});

// index表示している際に、indexの記事へアクセスした場合(_linkのクリックイベント)
$(".jsEventGrammarArticleIndex").on("click", function () {
  window.helpers.scrollTo.go($(".gram-index-article"), 80);
});
